import { action, computed, makeObservable, observable } from "mobx"
import { defer } from "../utils/promiseHelpers"

export class SuspenseObservable<T> {
  constructor(defaultValue?: T) {
    this.value = defaultValue
    makeObservable(this)
  }

  @observable private value?: T

  get(): T | undefined {
    return this.value
  }

  @computed get read$(): T {
    if (this.value == null) {
      throw this.onChange$()
    }
    return this.value
  }

  private inProgress?: defer.Deferred<void>

  onChange$(): Promise<void> {
    this.inProgress = this.inProgress ?? defer<void>()
    return this.inProgress.promise
  }

  @action set(value?: T): void {
    this.value = value
    if (value !== undefined) {
      this.inProgress?.resolve()
      this.inProgress = undefined
    }
  }
}
